import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { GoSidepanelComponent } from './component/go-sidepanel.component';
import { GoAnchorModule } from '@go-modules/directives/go-anchor/go-anchor.module';
import { A11yModule } from '@angular/cdk/a11y';
import { GoMonitorTabEventModule } from '@go-modules/directives/go-monitor-tab-event';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		GoAnchorModule,
		A11yModule,
		GoMonitorTabEventModule
	],
	declarations: [
		GoSidepanelComponent
	],
	exports: [
		GoSidepanelComponent
	]
})
export class GoSidepanelModule {}
